<script>
import { getIconPath as getImgPath } from "@/utils/getCorrectPath";

export default {
  name: "SubscriptionCancelUpgradeModal",

  data() {
    return {
      getImgPath: getImgPath,
    };
  },
};
</script>

<template>
  <div class="step-block">
    <div class="img-content">
      <img
        v-if="getImgPath('switch-plan')"
        :src="getImgPath('switch-plan')"
        class="item-icon"
        alt="icon"
      />
    </div>

    <div class="text">
      {{ $t("account.cancelSwitchPlanFull") }}
    </div>
  </div>
</template>
